module.exports = __webpack_public_path__ + "img/成都.9241b7a1.jpg";